import { forwardRef } from "react";
import { cn } from "@/utils/cn";

export interface SelectProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "className"> {
  className?: string;
  children: React.ReactNode;
}

const selectBase =
  "flex h-11 w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-base md:text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:border-slate-300 disabled:cursor-not-allowed disabled:opacity-50";

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <select ref={ref} className={cn(selectBase, className)} {...props}>
      {children}
    </select>
  )
);
Select.displayName = "Select";
